<template>
  <div class="spelling_card d_card_slim margin-bottom-25">
    <div @click="viewDetailSpellingError($event, spelling_result)" style="text-decoration: none; height: 100%">
      <div class="d-flex flex-row align-items-center" style="height: 100%">
        <div class="index_result">Trang {{ spelling_result.page }}</div>
        <div class="margin-left-10">
          <p class="spelling_card_content">{{ spelling_result.count }} lỗi</p>
        </div>
        <div class="ml-auto margin-right-10">
          <!--<div class="detail-view-icon"><FAIcon icon="fas fa-arrow-right" /></div>-->
          <el-button icon="el-icon-arrow-right" circle></el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpellingCard',
  props: ['spelling_result', 'index'],
  components: {},
  methods: {
    viewDetailSpellingError(e, spelling_result) {
      let pageCurrent = spelling_result.page

      this.$store.dispatch('docRes/spelling/updateCurrentSpellingPageDetail', parseInt(pageCurrent))
      this.$store.dispatch('docRes/spelling/updateIsShowSpellingPageDetail', true)

      document
        // .getElementById(`selectorSpellingResult-${pageCurrent}-0`)
        .getElementById(`page-${pageCurrent}`)
        .scrollIntoView({
          behavior: 'auto',
          inline: 'center',
          block: 'center',
        })
      document.getElementById(`page-preview-${pageCurrent}`).scrollIntoView({
        behavior: 'auto',
        inline: 'center',
        block: 'center',
      })

    },
  },
}
</script>

<style scoped>
.spelling_card {
  cursor: pointer;
}

.spelling_card_content {
  font-size: 18px;
  margin: 0;
  color: #ff0000;
}

.index_result {
  font-size: 18px;
  color: #6c757d;
  min-width: 100px;
  text-align: center;
}

.spelling_card.d_card_slim {
  border-left: 2px solid #ff0000;
  height: 60px;
  border-top: 1px solid #ececec;
}

.detail-view-icon {
  float: right;
  width: 40px;
  height: 40px;
  background-color: #007bff;
  text-align: center;
  vertical-align: middle;
}
</style>
